import React from "react";
import { User, AppContext, Appointment } from "../../../../context/appContext";
import { IRating } from "../interface/iRating";
import axios from "axios";
import { endpoints } from "../../../../endpoints/endpoints";
import { enqueueSnackbar } from "notistack";

export const AppointmentsParticipantContext = React.createContext<any>({});

const AppointmentsParticipantProvider = ({
  children,
}: any): React.JSX.Element => {
  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const [myAppointments, setMyAppointments] = React.useState<Appointment[]>([]);
  const isLoading = React.useRef(false);

  const [rating, setRating] = React.useState<IRating>({
    open: false,
    appointment: {} as Appointment,
  });

  const loadAppointments = React.useCallback((): void => {
    isLoading.current = true;

    axios
      .post(endpoints.appointment.myAppointments, {
        sessionId: user.sessionId,
      })
      .then((response) => {
        checkSession(response);
        setMyAppointments(response.data.data);
        isLoading.current = false;
      })
      .catch((error) => {
        console.error(error);
        isLoading.current = false;
      });
  }, [checkSession, user.sessionId]);

  const cancelAppointment = React.useCallback(
    (appointment: Appointment, reason: string): void => {
      axios
        .post(endpoints.appointment.cancelByParticipant, {
          sessionId: user.sessionId,
          appointmentId: appointment.id,
          reason: reason,
        })
        .then((response) => {
          checkSession(response);

          if (response.data.meta.status === "success") {
            const newAppointments = myAppointments.filter(
              (app) => app.id !== appointment.id
            );
            setMyAppointments(newAppointments);
            enqueueSnackbar("Der Termin wurde erfolgreich storniert!", {
              variant: "success",
            });
          } else {
            enqueueSnackbar("Stornierung ist fehlgeschlagen!", {
              variant: "error",
            });
          }
        })
        .catch((error) => {
          console.error(error);
          enqueueSnackbar("Stornierung ist fehlgeschlagen!", {
            variant: "error",
          });
        });
    },
    [checkSession, myAppointments, user.sessionId]
  );

  // Fetch appointments
  React.useEffect(() => {
    if (isLoading.current) return;
    loadAppointments();
  }, [loadAppointments]);

  const value: {} = React.useMemo(
    () => ({
      myAppointments,
      setMyAppointments,
      rating,
      setRating,
      loadAppointments,
      cancelAppointment,
    }),
    [myAppointments, rating, loadAppointments, cancelAppointment]
  );

  return (
    <AppointmentsParticipantContext.Provider value={value}>
      {children}
    </AppointmentsParticipantContext.Provider>
  );
};

export default AppointmentsParticipantProvider;
